import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Technology } from './components/Technology';
import { Benefits } from './components/Benefits';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { Locations } from './components/Locations';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-bodyon-dark text-bodyon-teal-dark font-sans selection:bg-bodyon-teal selection:text-white" data-id="element-1">
        <Header data-id="element-2" />

        <main data-id="element-3">
          <Hero data-id="element-4" />
          <Services data-id="element-5" />
          <WhyChooseUs data-id="element-6" />
          <Technology data-id="element-7" />
          <Benefits data-id="element-8" />
          <About data-id="element-9" />
          <Testimonials data-id="element-10" />
          <Locations data-id="element-11" />
          <Contact data-id="element-12" />
        </main>

        <Footer data-id="element-13" />
        <WhatsAppButton data-id="element-14" />
      </div>
    </LanguageProvider>;
}